<app-ui-toggle-button-group (valueChange)="onOmradeSelect($event)">
  <app-ui-toggle-button
    *ngFor="let omrade of buttonGroupData"
    [value]="omrade"
    [isActive]="omrade.displayName === 'Alla'"
    >{{ omrade.displayName }}</app-ui-toggle-button
  >
</app-ui-toggle-button-group>
